import styled, { css } from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

export const LessonCard = styled.article`
   width: 100%;
   border-radius: ${radius.lg};
   background: ${colors.surface};
   border: 1px solid ${(props) => (props.$open ? colors.brand : colors.line)};
   box-shadow: ${shadow.card};
   overflow: hidden;
`

export const TopWrapper = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 12px;
   padding: 16px 20px;
   border-bottom: 1px solid ${colors.line};
`

export const NameWrapper = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   min-width: 0;
`

export const Avatar = styled.span`
   display: grid;
   place-items: center;
   width: 40px;
   height: 40px;
   flex-shrink: 0;
   border-radius: ${radius.pill};
   font-family: ${font.text};
   font-size: 17px;
   font-weight: 800;
   color: ${colors.brandDeep};
   background: ${colors.brandSoft};
`

export const Caption = styled.span`
   display: block;
   font-family: ${font.text};
   font-size: 12px;
   font-weight: 600;
   color: ${colors.muted};
`

export const NameText = styled.p`
   font-family: ${font.text};
   font-size: 16px;
   font-weight: 800;
   color: ${colors.ink};
`

export const DataWrapper = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
   flex-shrink: 0;
`

export const DataText = styled.span`
   padding: 6px 12px;
   border-radius: ${radius.pill};
   font-family: ${font.text};
   font-size: 13px;
   font-weight: 700;
   font-variant-numeric: tabular-nums;
   color: ${colors.muted};
   background: ${colors.bg};
`

export const Done = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 4px;
   padding: 6px 10px;
   border-radius: ${radius.pill};
   font-family: ${font.text};
   font-size: 13px;
   font-weight: 700;
   color: ${colors.success};
   background: ${colors.successSoft};
`

export const BottomWrapper = styled.div`
   display: flex;
   flex-direction: column;
   gap: 12px;
   padding: 16px 20px 20px;
`

export const Note = styled.p`
   display: flex;
   gap: 10px;
   padding: 12px 14px;
   border-radius: ${radius.md};
   font-family: ${font.text};
   font-size: 15px;
   font-weight: 500;
   line-height: 1.5;
   color: ${colors.ink};
   background: ${(props) => (props.$muted ? colors.amberSoft : colors.bg)};

   svg {
      flex-shrink: 0;
      margin-top: 3px;
      color: ${(props) => (props.$muted ? colors.amberDeep : colors.brand)};
   }
`

export const Footer = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 12px;
   flex-wrap: wrap;
`

export const LessonLink = styled.a`
   display: flex;
   flex-direction: column;
   gap: 2px;
   padding: 8px 14px;
   border-radius: ${radius.md};
   border: 1.5px solid ${colors.line};
   text-decoration: none;
   transition: border-color 0.15s ease;

   &:hover {
      border-color: ${colors.brand};
   }
`

export const LinkLabel = styled.span`
   font-family: ${font.text};
   font-size: 12px;
   font-weight: 600;
   color: ${colors.muted};
`

export const LinkName = styled.span`
   display: flex;
   align-items: center;
   gap: 6px;
   font-family: ${font.text};
   font-size: 15px;
   font-weight: 800;
   color: ${colors.brandDeep};
`

// Залишено для сумісності з місцями, що імпортують Text
export const Text = styled.p`
   font-family: ${font.text};
   font-size: 15px;
   color: ${colors.ink};
`

const button = css`
   padding: 12px 22px;
   border-radius: ${radius.md};
   font-family: ${font.text};
   font-size: 15px;
   font-weight: 800;
   cursor: pointer;
   transition: transform 0.08s ease, box-shadow 0.08s ease, background 0.15s ease;
`

export const HomeworkBtn = styled.button`
   ${button};
   ${(props) => props.$secondary ? css`
      color: ${colors.brandDeep};
      background: ${colors.brandSoft};
   ` : css`
      color: #FFFFFF;
      background: ${colors.brand};
      box-shadow: ${shadow.button(colors.brandDeep)};

      &:active {
         transform: translateY(3px);
         box-shadow: ${shadow.button("transparent")};
      }
   `}

   @media (max-width: 560px) {
      width: 100%;
   }
`

export const TeacherHomeworkBtn = styled.button`
   ${button};
   padding: 9px 16px;
   color: ${(props) => (props.$active ? colors.brandDeep : "#FFFFFF")};
   background: ${(props) => (props.$active ? colors.brandSoft : colors.brand)};
`
